import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';

import { OnsetExamDataDto } from 'src/shared/dtos/onset-exam-data-dto';

@Injectable({
    providedIn: 'root',
})
export class ConnectorAuthService {
    isLoggedIn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    onsetExamDataDto: BehaviorSubject<OnsetExamDataDto> = new BehaviorSubject<OnsetExamDataDto>(null);

    login(onsetExamDataDto: OnsetExamDataDto) {
        this.onsetExamDataDto.next(onsetExamDataDto);
        this.isLoggedIn.next(true);
    }

}
